import { useEffect } from 'react';
import { type ILayout, useLayout } from '../../core';

const Footer = () => {
  const { config } = useLayout();
  useEffect(() => {
    updateDOM(config);
  }, [config]);
  return (
    <div className="text-gray-900 order-2 order-md-1">
      <span className="text-muted fw-semibold me-1">{new Date().getFullYear().toString()}&copy;</span>
      <a className="text-gray-800 text-hover-primary" href="https://uniolab.com.br/" rel="noreferrer" target="_blank">
        Uma solução uniolab
      </a>
    </div>
  );
};

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true');
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true');
  }
};

export { Footer };
